import { HTTP } from '@/http';
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      displaySnackbar: 'application/displaySnackbar',
      logout: 'auth/logout',
    }),
    setInterceptors() {
      const responseHandler = (response) => {
        if (response.data.data && response.data.data.message &&
            response.data.data.message === 'session not valid' &&
            this.$store.state.auth.session.auth) {
          this.logout()
            .then(() => {
              this.displaySnackbar({
                text: this.$i18n.t('store.login.sessionExpired'),
                time: 5,
                type: 'error',
                centered: false,
              });
            });
          this.$router.push({ name: 'login' });
          return Promise.reject(response);
        }
        return Promise.resolve(response);
      };
      const errorHandler = (error) => {
        return Promise.reject(error);
      };
      HTTP.interceptors.response.use(responseHandler, errorHandler);
    },
  },
};



// WEBPACK FOOTER //
// ./src/interceptors.js